import React from 'react';
import Icon from './Icon';

type Tone = 'neutral' | 'accent' | 'success' | 'warn' | 'danger' | 'info';

interface ChipProps {
  tone?: Tone;
  size?: 'sm';
  dot?: boolean;
  icon?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Chip({ tone = 'neutral', size, dot, icon, children, className = '', onClick }: ChipProps) {
  const cls = ['t-chip', `t-chip--${tone}`, size && `t-chip--${size}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      {dot && <span className="t-chip-dot" />}
      {icon && <Icon name={icon} size={10} />}
      {children}
    </span>
  );
}
